import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { Icon } from '@/common/components/Icons/Icon';
import { IllustrationShield } from '@/common/components/Illustrations/IllustrationShield';
import { ROUTES } from '@/common/constants/routes';
import { ESHealthInsuranceAddBirthdateModal } from '@/common/containers/Dashboard/Home/ESHomePage/ESHealthInsuranceAddBirthdateModal/ESHealthInsuranceAddBirthdateModal';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetInsuranceAvailableOptions } from '@/common/integrations/menhir/employee/insurance/insurance.hooks';
import { notify } from '@/common/utils/toast/toast';
import { useRouter } from 'expo-router';

export function ESHealthInsuranceAddCard() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { employee } = useEmployeeDetails();
  const { push } = useRouter();

  const { plans, error } = useGetInsuranceAvailableOptions();

  const handlePress = () => {
    if (employee?.birthDate) {
      if (error?.statusCode || !plans || plans.length === 0) {
        notify({
          message: t('dashboard.home.add_insurance.error_toast.message'),
          type: 'error',
        });
      } else {
        push({
          pathname: ROUTES.INSURANCE_AVALIABLE_PLANS,
          params: { lc: 'true' },
        });
      }
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      <CardAction
        title={t('dashboard.home.add_insurance.card.title')}
        description={t('dashboard.home.add_insurance.card.description')}
        size="md"
        illustration={{
          asset: <IllustrationShield width={160} height={160} />,
        }}
        action={<Icon icon="chevron-right" />}
        backgroundColor="accentPrimary10"
        onPress={handlePress}
      />
      {showModal && (
        <ESHealthInsuranceAddBirthdateModal
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
